export const taxesEs = {
  taxes: `Impuestos`,
  taxes_management: `Gestión De Impuestos`,
  add_tax: `Agregar impuesto`,
  edit: `Editar`,
  delete: `Eliminar`,
  active: `Activo`,
  inactive: `Inactivo`,
  yes: `Sí`,
  no: `No`,
  code: `Código`,
  description: `Descripción`,
  tax_type: `Tipo de impuesto`,
  rate: `Tasa`,
  withholding: `Retención`,
  actions: `Acciones`,
  exempt: `Exento`,
  tax: `Impuesto`,
  delete_tax_dialog: `¿Está seguro de que desea eliminar este impuesto?`,
  VAT_label: `VAT - Impuesto sobre el Valor Añadido`,
  IGIC_label: `IGIC - Impuesto General Indirecto Canario`,
  IRPF_label: `IRPF - Impuesto sobre la Renta de las Personas Físicas`,
  WHT_label: `WHT - Impuesto de Retención`,
  select_compliance_standard: `Por favor seleccione el estándar de cumplimiento`,
  VeriFactu_label: `VeriFactu`,
  SII_label: `SII`,
  SDI_label: `SDI`,
  successfully_deleted: `Impuesto eliminado con éxito`,
  delete_failed: `Error al eliminar el impuesto`,
  something_went_wrong: `Algo salió mal`,
  is_withholding_tax: `¿Es impuesto de retención`,
  compliance_standard: `Estándar de cumplimiento`,
  edit_tax: `Editar impuesto`,
  exempt_code: `Código de exención`,
  tax_type_required: `El tipo de impuesto es obligatorio`,
  rate_required: `La tasa es obligatoria`,
  rate_min: `La tasa debe ser mayor o igual a 0`,
  exempt_code_required: `El código de exención es obligatorio para el impuesto de retención`,
  compliance_standard_required: `El estándar de cumplimiento es obligatorio`,
  please_select: `Por favor seleccione`,
  select_tax_type: `Por favor seleccione el tipo de impuesto`,
  code_disabled_withholding: `El código está deshabilitado cuando la retención está marcada`,
  organization_not_found: `No se encontró organización para el usuario actual`,
  invalid_tax_rate_range: `La tasa de impuesto debe estar entre 0 y 100`,
  exempt_code_required_for_zero_rate: `Se requiere un código de exención cuando la tasa de impuesto es 0%`,
  tax_code_required: `El código tributario es obligatorio`,
  duplicate_tax_rate_for_exemptcode: `Ya existe un impuesto activo con Tipo de Impuesto '{{0}}', Tasa '{{2}}%' y Código de Exención '{{1}}'`,
  duplicate_tax_rate_for_code: `Ya existe un impuesto activo con Tipo de Impuesto '{{0}}', Tasa '{{2}}%' y Código '{{1}}'`,
  tax_not_found: `Impuesto no encontrado`,
  tax_updated_success: `Impuesto actualizado exitosamente`,
  tax_created_success: `Impuesto creado exitosamente`,
  error_fetching_tax_data: `Error al obtener los datos del impuesto`,
  code_is_required: `El código es obligatorio`,
};
